const SATURATION = 1.0;

const GRADIENTS = [
    // night
    [
        [0.0, "#000000"],
        [0.25, "#02020d"],
        [0.5, "#07071e"],
        [0.75, "#050c2d"],
        [1.0, "#010e34"]
    ],

    // dawn
    [
        [0.0, "#011e40"],
        [0.25, "#302756"],
        [0.5, "#913164"],
        [0.75, "#d65545"],
        [1.0, "#e2762c"]
    ],

    // day
    [
        [0.0, "#1e3f7c"],
        [0.25, "#34568e"],
        [0.5, "#6789b6"],
        [0.75, "#a0bfdd"],
        [1.0, "#bdd8ef"]
    ],

    // dusk
    [
        [0.0, "#011e40"],
        [0.25, "#221f49"],
        [0.5, "#5b1447"],
        [0.75, "#820d29"],
        [1.0, "#891f14"]
    ],

    // night
    [
        [0.0, "#000000"],
        [0.25, "#02020d"],
        [0.5, "#07071e"],
        [0.75, "#050c2d"],
        [1.0, "#010e34"]
    ]
];

export function rgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
}

export function hsl(r, g, b) {
    (r /= 255), (g /= 255), (b /= 255);
    let max = Math.max(r, g, b),
        min = Math.min(r, g, b);
    let h,
        s,
        l = (max + min) / 2;

    if (max == min) {
        h = s = 0;
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }

    return [h, s, l];
}

function hslCss(r, g, b, saturation) {
    const [h, s, l] = hsl(r, g, b);

    return `hsl(${(h * 360).toFixed()}, ${(
        s *
        saturation *
        100
    ).toFixed()}%, ${(l * 100).toFixed()}%)`;
}

export function interpolate(p, a, b) {
    return a + (b - a) * p;
}

function interpolateColor(p, a, b) {
    const from = rgb(a);
    const to = rgb(b);

    return [
        Math.round(interpolate(p, from.r, to.r)),
        Math.round(interpolate(p, from.g, to.g)),
        Math.round(interpolate(p, from.b, to.b))
    ];
}

function interpolateGradients(p, a, b) {
    return a.map((aStop, index) => {
        const bStop = b ? b[index] : a[index];

        return [
            interpolate(p, aStop[0], bStop[0]),
            interpolateColor(p, aStop[1], bStop[1])
        ];
    });
}

export function map(n, low1, high1, low2, high2) {
    return low2 + (high2 - low2) * ((n - low1) / (high1 - low1));
}

export function ease(p) {
    if (p < 0.5) {
        return 2 * p * p;
    } else {
        return -2 * p * p + 4 * p - 1;
    }
}

export function gradientAt(progress) {
    let from = Math.max(Math.floor(progress * (GRADIENTS.length - 1)), 0);
    let to = Math.max(Math.ceil(progress * (GRADIENTS.length - 1)), 1);

    const step = 1 / (GRADIENTS.length - 1);
    const p = map(progress, from * step, to * step, 0.0, 1.0) || 0.0;
    const gradient = interpolateGradients(p, GRADIENTS[from], GRADIENTS[to]);

    return gradient;
}

export function gradientCssAt(progress) {
    const gradient = gradientAt(progress);

    return (
        "linear-gradient(180deg," +
        gradient.map(([position, color]) => {
            return `${hslCss(...color, SATURATION)} ${(
                position * 100
            ).toFixed()}%`;
        }) +
        ") fixed"
    );
}
